"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.radius = exports.center = exports.viewBox = exports.borderRadiusPath = void 0;
exports.borderRadiusPath = 'M12 3.7998C7.47131 3.7998 3.80005 7.47107 3.80005 11.9998C3.80005 16.5285 7.47131 20.1998 12 20.1998C16.5288 20.1998 20.2001 16.5285 20.2001 11.9998C20.2001 7.47107 16.5288 3.7998 12 3.7998ZM5.65459 11.9998C5.65459 8.49531 8.49555 5.65435 12 5.65435C15.5045 5.65435 18.3455 8.49531 18.3455 11.9998C18.3455 15.5043 15.5045 18.3453 12 18.3453C8.49555 18.3453 5.65459 15.5043 5.65459 11.9998Z';
exports.viewBox = '0 0 24 24';
exports.center = { x: 12, y: 12 };
exports.radius = 5;
